import { render } from "./DefaultIcon.vue?vue&type=template&id=310ca252"
import script from "./DefaultIcon.vue?vue&type=script&lang=js"
export * from "./DefaultIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__